import { formatDate } from '@/utils'

export const getRoadmapState = roadmap => {
  const {
    fact_to_finalizing_date,
    plan_to_finalizing_date,
    plan_act_sign_date,
    fact_act_sign_date,
    plan_payment_date
  } = roadmap

  if (!fact_to_finalizing_date) {
    return {
      status: 'Выпуск ТО',
      date: plan_to_finalizing_date
    }
  }
  if (!fact_act_sign_date) {
    return {
      status: 'Подписание акта',
      date: plan_act_sign_date
    }
  }

  return {
    status: 'Ожидание оплаты',
    date: plan_payment_date
  }
}

export const getStyleObject = task => {
  return {
    dates: new Date(formatDate(task.expiration_date, 'YYYY-MM-DD')),
    customData: {
      label: task.name,
      code: task.object.code,
      contract_id: task.object_id,
      customer: task.object.customer.name,
      manual_done: task.manual_done,
      id: task.id
    }
  }
}
